import { Box, Card, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomDataGrid from "../../shared/components/CustomDataGrid";
import { handleError } from "../../shared/functions/handleError";
import { usePagination } from "../../shared/hooks/usePagination";
import { IModule } from "../../shared/interfaces/module/IModule";
import { useModuleColumns } from "./hooks/useModuleColumns";
import { ModuleService } from "./service";

const AdminModule = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IModule[] | undefined>(undefined);

  const columns = useModuleColumns();
  const {
    pagination,
    count,
    setPagination,
    totalPages,
    setTotalPages,
    setCount,
    changeFilterHandler,
  } = usePagination({
    perPage: 30,
  });

  useEffect(() => {
    ModuleService.get({ ...pagination, page: pagination?.page + 1 })
      .then((response) => {
        setCount(response?.count);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
        setData(response.data);
      })
      .catch(handleError);
  }, [pagination, setTotalPages, setCount]);
  return (
    <Card sx={{ marginTop: "30px" }}>
      <Box
        sx={{
          pb: "20px",
        }}
      >
        <Grid container spacing={2} sx={{ alignItems: "center" }}>
          <Grid size={{ xs: 12, md: 6, lg: 3 }}>
            <TextField
              onChange={(e) => {
                changeFilterHandler("name", e.target.value);
              }}
              label={t("general.searchByName")}
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
      <CustomDataGrid
        columns={columns}
        rows={data || []}
        rowCount={count}
        setPagination={setPagination}
        pagination={pagination}
        loading={data === undefined}
        hasNextPage={totalPages < pagination?.page}
      />
    </Card>
  );
};
export default AdminModule;
